/* eslint-disable @typescript-eslint/naming-convention */
import { AnalyticsEvent } from '@shure/shared/models';
export class DeviceDiscoveredAnalyticsEvent implements AnalyticsEvent {
	public readonly event = 'device_discovered';
	public readonly properties: {
		hardware_id: string;
		interface_version: string;
		model: string;
		virtual: boolean;
	};
	constructor(
		hardwareId: string | undefined,
		interfaceVersion: string | undefined,
		model: string | undefined,
		virtual: boolean
	) {
		this.properties = {
			hardware_id: hardwareId ?? '',
			interface_version: interfaceVersion ?? '',
			model: model ?? '',
			virtual: virtual
		};
	}
}
